import React from "react";
import { PlusOutlined, FileExcelOutlined } from "@ant-design/icons";
import {
  Drawer,
  Button,
  PageHeader,
} from "antd";
import { useState } from "react";
import AdminBreadCrumb from "../../components/layout/AdminBreadCrumb";
import { ADD_MODE, DEFAULT_MASTER_DRAWER_WIDTH } from "../../utility/Constants";
import OccupationEntry from "../../components/masters/occupation/OccupationEntry";
import OcuupationList from "../../components/masters/occupation/OccupationList";
import DrawableCloseIcon from "../../components/common/DrawableCloseIcon";
import { ALL_OCCUPATION_XLS_URL } from "../../utility/URL";
import commonUtility from "../../utility/Utils";


const Occupation = () => {
  const [visible, setVisible] = useState(false);
  const [occupationAddData, setOccupationAddData] = useState({
    id: 0,
    occupation_name: '',
    mode: ADD_MODE
  });

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };
  

  return (
    <div className="inside-main-content">
      <AdminBreadCrumb />

      <div className="box-style">
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title="Occupation"
          subTitle=""
          extra={[
            <Button key="1" className="custom-button-white" shape="round" onClick={showDrawer}>
              <PlusOutlined /> Add
            </Button>,

            <Button key="2" className="custom-button-white" shape="round" size="medium" onClick={() => commonUtility.openInNewTab(ALL_OCCUPATION_XLS_URL)}>
              <FileExcelOutlined /> Excel
            </Button>,
          ]}
        ></PageHeader>

        <Drawer
          title="Add new occupation"
          width={DEFAULT_MASTER_DRAWER_WIDTH}
          onClose={onClose}
          visible={visible}
          bodyStyle={{
            paddingBottom: 80,
          }}
          destroyOnClose={true}
          closeIcon={<><DrawableCloseIcon /></>}
        >
          <OccupationEntry data={occupationAddData} onDrawerClose={onClose} />
        </Drawer>

        <div className="tableView">
          <div className="form-content">
            <OcuupationList />
          </div>
        </div>

      </div>
    </div>
  )
}

export default Occupation